import { acronymEnergyTypeSchema } from "@qivia/schemas-shared";
import { z } from "zod";
import { vehicleTypeSchema } from "../_shared";

export const getHomeChargingEligibleVehiclesResponse = z.array(
  z.object({
    uuid: z.uuid(),
    vin: z.string(),
    energyType: acronymEnergyTypeSchema,
    registrationNumber: z.string(),
    vehicleType: vehicleTypeSchema.nullable().optional(),
    driverUuid: z.uuid().nullable().optional(),
  }),
);

export type GetHomeChargingEligibleVehiclesResponse = z.infer<
  typeof getHomeChargingEligibleVehiclesResponse
>;
